import { Dimension } from '@supermeme-ai/types'

export const scaleDownImage = (
  imageWidth: number,
  imageHeight: number,
  maxImageDimension: number,
): Dimension => {

  // rectangle - width > height
  if (imageWidth > imageHeight) {
    if (imageWidth <= maxImageDimension) {
      // if image is less than or equal to max size return actual size
      return {
        width: Math.round(imageWidth),
        height: Math.round(imageHeight),
      }
    }

    // calculate scale and return new dimensions
    const scale = maxImageDimension / imageWidth
    return {
      width: Math.round(imageWidth * scale),
      height: Math.round(imageHeight * scale),
    }
  }

  // rectangle - height > width
  if (imageHeight > imageWidth) {
    if (imageHeight <= maxImageDimension) {
      // if image is less than or equal to max size return actual size
      return {
        width: Math.round(imageWidth),
        height: Math.round(imageHeight),
      }
    }

    // calculate scale and return new dimensions
    const scale = maxImageDimension / imageHeight
    return {
      width: Math.round(imageWidth * scale),
      height: Math.round(imageHeight * scale),
    }
  }

  // square
  if (imageHeight === imageWidth) {
    if (imageHeight <= maxImageDimension && imageWidth <= maxImageDimension) {
      // if image is less than or equal to max size return actual size
      return {
        width: Math.round(imageWidth),
        height: Math.round(imageHeight),
      }
    }

    // calculate scale and return new dimensions
    const scale = maxImageDimension / imageHeight
    return {
      width: Math.round(imageWidth * scale),
      height: Math.round(imageHeight * scale),
    }
  }

  // should never get here
  return {
    width: Math.round(imageWidth),
    height: Math.round(imageHeight),
  }
}

export const addPaddingAndReturnImage = (
  imageSrc: string,
  targetWidth: number,
  targetHeight: number,
  borderWidth: number,
  borderColor: string,
  callback: (dataUrl: string) => void,
) => {
  // Create an image element
  const image = new Image()
  image.onload = function () {
    // Create a canvas element
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    // Set canvas dimensions to target size plus border width
    canvas.width = targetWidth + 2 * borderWidth
    canvas.height = targetHeight + 2 * borderWidth

    // Calculate padding
    const ratio = Math.min(targetWidth / image.width, targetHeight / image.height)
    const newWidth = image.width * ratio
    const newHeight = image.height * ratio
    const xOffset = (targetWidth - newWidth) / 2 + borderWidth
    const yOffset = (targetHeight - newHeight) / 2 + borderWidth

    // Fill background with white
    ctx!.fillStyle = borderColor
    ctx!.fillRect(0, 0, canvas.width, canvas.height)

    // Draw image on canvas with padding
    ctx!.drawImage(image, xOffset, yOffset, newWidth, newHeight)

    // Call callback with new image data URL
    callback(canvas.toDataURL())
  }

  // Handle CORS issues if necessary
  image.crossOrigin = 'Anonymous'

  // Load the image
  image.src = imageSrc
}
